enum EventInstanceState  {
  Normal = 0,
  Archived = 1,
  Freezed = 2
}
export default Object.freeze(EventInstanceState);

